<template>
        <div class="card-body card" v-if="isMounted">
            <el-form style="height: 50px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="筛选学生">
                            <el-select v-model="$parentInfo.headTeacherReferrerList.student_id" clearable placeholder="请选择学生"
                                       filterable remote
                                       :remote-method="handleSearchStudent"
                                       @change="changeStudent($parentInfo.headTeacherReferrerList.student)">
                                <el-option
                                        v-for="item in $parentInfo.headTeacherReferrerList.students"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="兑换情况">
                            <el-select v-model="$parentInfo.headTeacherReferrerList.type" clearable placeholder="请选择兑换情况"
                                       filterable remote
                                       @change="changeStudent()">
                                <el-option
                                        v-for="item in types"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>



            </el-form>
            <table class="table" v-loading="$parentInfo.headTeacherReferrerList.loading">
                <thead>
                <tr>
                    <th style="min-width: 70px">推荐人</th>
                    <th>共推荐人数</th>
                    <th>兑换情况</th>
                    <th>可兑换人数</th>
                    <th v-if="powers.includes(91)">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in orderHeadTeacherReferrers">
                    <td style="min-width: 70px">{{item.name}}</td>
                    <td>
                        <el-popover
                                placement="right"
                                trigger="click">
                            <div v-if="item.id===$parentInfo.headTeacherReferrerList.referrer">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th style="width: 80px">姓名</th>
                                        <th style="width: 100px">日期</th>
                                        <th>状态</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="one in item.referee">
                                        <td> {{one.name}}</td>
                                        <td>{{$moment(one.created_at).format('YYYY-MM-DD')}}</td>
                                        <td>
                                            <el-button :type=computeType(one.suffice) size="mini"
                                                       @click="handleStudentInformation(one.id,one.name)">满5
                                            </el-button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <el-button style="position: relative;" @click="handleShowReferee(item.id)" slot="reference">
                                {{item.referee_number}}人
                            </el-button>
                        </el-popover>
                    </td>
                    <td>
                        <p v-for="one in item.exchange_situation">
                            <b>活动:</b>{{one.activity_name}}—— <b>礼品:</b>{{one.present_name}}<span
                                v-if="one.discount!=0">({{one.discount_type}})</span>——<b>兑换时间:</b>{{one.created_at}}——<b>兑换人:</b>{{one.operator_name}}
                        </p>
                    </td>
                    <td>
                        {{item.can_exchange_number}}人
                    </td>
                    <td>
                        <el-button size="mini" @click="handleExchangePresent(item.id)"
                                   :disabled="item.can_exchange_number==0">兑换礼品
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="text-center m-t-10">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="$parentInfo.headTeacherReferrerList.total">
                </el-pagination>
            </div>
        </div>
</template>

<script>
    export default {
        name: "HeadTeacherReferrerList",
        data() {
            return {
                currentPage: 1,
                currentPageSize: 10,
                isMounted: false,
                isShow: false,
                types:[
                    {
                        id:'all',
                        name:'全部'
                    },
                    {
                        id:'active',
                        name:'未完全兑换'
                    },
                    {
                        id:'finished',
                        name:'已全部兑换'

                    }
                ]
            }
        },
        props: {
            employee: {},
        },
        mounted() {
            this.isMounted = true;
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleIndexHeadTeacherReferrerList();
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            orderHeadTeacherReferrers: function () {
                return this._.orderBy(this.$parentInfo.headTeacherReferrerList.headTeacherReferrers, 'referee_number', 'desc');
            },
        },
        methods: {
            handleIndexHeadTeacherReferrerList(currentPage = 1, currentPageSize = 10) {
                this.$parentInfo.headTeacherReferrerList.loading = true;
                this.$wApi.send(this.$parentInfo.path, 'get_headTeacherReferrerList', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'employee': this.employee,
                    'student_id': this.$parentInfo.headTeacherReferrerList.student_id,
                    'type':this.$parentInfo.headTeacherReferrerList.type
                });
            },
            handleShowReferee(id) {
                this.isShow = !this.isShow;
                this.$parentInfo.headTeacherReferrerList.referrer = id;
            },
            handleExchangePresent(id) {
                this.$Win.openModal('Dialog_AddReferrerExchangePresent', 400, 300, '兑换礼品', {
                    'id': id,
                    'employee_id':this.employee,
                });
                // this.$Win.openModal('/referrerExchangePresent/' + id + '/edit', 550, 300, '兑换礼品');
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexHeadTeacherReferrerList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexHeadTeacherReferrerList(this.currentPage, this.currentPageSize)
            },
            handleStudentInformation(student_id, title) {
                this.$store.commit('addTab', {
                    targetName: 'student',
                    parameter: {id: student_id, status: null},
                    title: title
                });
            },
            handleSearchStudent(query) {
                this.$wApi.send(this.$parentInfo.path, 'get_student', {
                    'employee': this.employee,
                    'studentKeyName': query,
                });
            },
            changeStudent() {
                this.currentPage=1;
                this.currentPageSize=10;
                this.handleIndexHeadTeacherReferrerList(1,10);
            },
            computeType(query) {
                return query === 1 ? 'success' : 'warning';
            }
        }
    }
</script>

<style scoped>
    .refereeNumber {
        margin: 4px;
    }
</style>
